import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "../styles/accordion.module.css";
import { AccordionItem } from "./index.js";
import { LONDON_3 } from "../../typography/src/constants";

export const Accordion = ({
  items,
  openIndexOnMount = -1,
  animationTimeInMilliseconds = 300,
  headingElement = "h3",
  headingSizing = LONDON_3,
  onItemClick,
  classname = "",
}) => {
  const [openIndex, setOpenIndex] = useState(openIndexOnMount);

  const handleTitleClick = (event, index) => {
    const newOpenIndex = openIndex === index ? -1 : index;

    if (onItemClick) {
      onItemClick(event.target, items[index], newOpenIndex === index);
    }

    setOpenIndex(newOpenIndex);
  };

  const renderAccordionItems = () =>
    items.map(({ contentId, title, content }, index) => (
      <li key={contentId} className={styles.item}>
        <AccordionItem
          headingElement={headingElement}
          headingSizing={headingSizing}
          title={title}
          isOpen={openIndex === index}
          titleOnClickHandler={(event) => handleTitleClick(event, index)}
          contentId={contentId}
          dataTestId={contentId}
          animationTimeInMilliseconds={animationTimeInMilliseconds}
        >
          {content}
        </AccordionItem>
      </li>
    ));

  return <ul className={classname}>{renderAccordionItems()}</ul>;
};

Accordion.propTypes = {
  /**
   Array  of items used to define the accordion
  */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      contentId: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  /**
   Callback that returns event.target, itemClicked and openState
  */
  onItemClick: PropTypes.func,
  /**
   The default item to pre-open the accordion to
  */
  openIndexOnMount: PropTypes.number,
  /**
   Time for each open/close animation to take, 0 removes animaations
  */
  animationTimeInMilliseconds: PropTypes.number,
  /**
   Allows you to add additional classes to the accordion
  */
  classname: PropTypes.string,
  /**
   Element to use for the headings inside the accordion, must be h1, h2, h3, h4 or h5, defaults to h3
   */
  headingElement: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  /**
   Sizing to use for the headings inside the accordion, defaults to london 3
   */
  headingSizing: PropTypes.string,
};
